import React, { useCallback } from 'react';

import { SvgCheck, Icon } from '@tmapy/style-guide';

import { useAppContext, useHistoryAction } from '../../hooks';
import type { ExportToolResponse } from '../../openapi/types/ExportTool';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

type ExportToolListItemProps = ExportToolResponse & { formatName?: string; gpTaskName?: string };

export const ExportToolListItem: React.FC<ExportToolListItemProps> = ({
  gpTaskName,
  formatName,
  ...props
}) => {
  const { appType } = useAppContext();
  const routeToExportToolDetail = useHistoryAction('vydejExportToolDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejExportToolDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToExportToolDetail();
      }
    },
    [routeToExportToolDetail, appType, props.id],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>{formatName ?? props.format}</td>
      <td>{props.is_package ? '' : (gpTaskName ?? props.gp_task)}</td>
      <td>{props.tool_name}</td>
      <td className='sg-a-ta-c'>
        {props.is_default && <Icon element={<SvgCheck />} size="sml" />}
      </td>
      <td className='sg-a-ta-c'>
        {props.is_package && <Icon element={<SvgCheck />} size="sml" />}
      </td>
    </tr>
  );
};
